import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-internet-lan',
  templateUrl: './page-internet-lan.component.html',
  styleUrls: ['./page-internet-lan.component.css']
})
export class PageInternetLANComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
